import axios from "axios";
import { getEndpoint } from "../../configHelper";

export default axios.create({
    baseURL:  getEndpoint(),
});
